import { GroupManagement } from "@/pages/medewerkers/$userId/groepen/GroupManagement"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/medewerkers/$userId/groepen/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = Route.useParams()

  return <GroupManagement userId={Number(userId)} />
}
